import { Navigate } from 'react-router-dom';
import { useOrganizationTheme } from '../hooks/useOrganizationTheme';

export default function WeCareHrRoute({ children }) {
  const { theme, loading } = useOrganizationTheme();
  if (loading) return <p role="status" className="p-6 text-sm text-gray-600 dark:text-gray-300">Checking workspace availability…</p>;
  if (theme?.slug !== 'wecare-health') return <Navigate to="/admin" replace />;
  return children;
}
